import Image from '@/components/UI/Image';
import { EFArrow } from '@/components/UI/svg/Search';
import { htmlDecode } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import moment from 'moment';
import { useEffect, useState } from 'react';
import sanitizeHtml from 'sanitize-html';
import css from './index.module.scss';
export default function ProductItem({ hasImg, pressItem, isMobile = false }: any) {
    const { Link, useRouter, useLang } = useGlobal();
    const { locale } = useRouter();
    // const locale = ENGLISH_LANG.includes(oriLang) ? 'en' : oriLang
    const [desc, setDesc] = useState('');
    const { t } = useLang('shared');

    const getDataLayer = (name: string) => {
        return {
            event: 'uaEvent',
            event_name: 'select_search_result',
            list_name: 'EcoFlow Blog',
            title_name: name,
            button_name: 'learn_more',
        };
    };

    const getDefaultDesc = (): void => {
        const content = sanitizeHtml(pressItem.excerpt || '', {
            allowedTags: [],
            allowedAttributes: {},
        });
        setDesc(htmlDecode(content));
        /*const arr = content.split(/[(\r\n)\r\n]+/)
    for (let i = 0; i < arr.length; i++) {
      if (arr[i]) {
        setDesc(htmlDecode(arr[i]))
        return
      }
    }*/
    };
    useEffect(() => {
        getDefaultDesc();
    }, [pressItem]);
    const imgItem = (
        <>
            <div className="pressImg">
                <Image src={pressItem.ogImage} preview={'false'} fallback="/img/search/error.png" layout="fill" className="fullImgs" alt={pressItem.title} />
            </div>
            <div className="pressInfo font-family-regular">
                <p className="time" style={{ fontWeight: 400 }}>
                    {moment(pressItem.modified).format('YYYY-MM-DD')}
                </p>
                <h3 style={{ fontWeight: 600 }}>{htmlDecode(pressItem.title)}</h3>
                <p className="desc font-family-regular">{desc}</p>
                <Link
                    href={
                        locale === 'jp' ? 'https://jp.ecoflow.com/blogs/ecoflow-blogs' : `${process.env.NEXT_PUBLIC_BLOG_HOST}/${locale}/${pressItem.postName}/`
                    }
                    ariaLabel={pressItem.title}
                    dataLayer={getDataLayer(htmlDecode(pressItem.title))}
                >
                    <span className="font-family-medium link">
                        {t('support.site_support_learn_more')}
                        <EFArrow />
                    </span>
                </Link>
            </div>
        </>
    );
    const otherPress = (
        <div className="otherPress">
            <h3>{htmlDecode(pressItem.title)}</h3>
            <p className="desc">{desc}</p>
            <Link
                href={locale === 'jp' ? 'https://jp.ecoflow.com/blogs/ecoflow-blogs' : `${process.env.NEXT_PUBLIC_BLOG_HOST}/${locale}/${pressItem.postName}/`}
                ariaLabel={pressItem.postName}
            >
                {locale === 'jp' ? 'https://jp.ecoflow.com/blogs/ecoflow-blogs' : `${process.env.NEXT_PUBLIC_BLOG_HOST}/${locale}/${pressItem.postName}/`}
                <EFArrow />
            </Link>
        </div>
    );
    return <div className={css.pressItem}>{hasImg ? imgItem : otherPress}</div>;
}
